"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHyperImmunised = createHyperImmunised;
const events_1 = require("../../../events");
const patientCondition_1 = require("../../../forms/ltx/patientCondition");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
function createHyperImmunised({ formatMessage }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.hyperImmunised);
    if (event === undefined) {
        return { value: "-" };
    }
    return {
        value: event.value === patientCondition_1.HyperImmunised.YES
            ? formatMessage(shared_1.yesNoMessages.YES)
            : "-",
        timestamp: event.timestamp,
        origin: event.origin
    };
}
